<template>
  <div>
    <DialogWrapper v-if="canNotLottery" dialogType="canNotLottery" dialogHeight="250px">
      <template #title>
        <p>温馨提示</p>
      </template>
      <template #main-content>
        <div :class="$style.content">
          <p style="color: red; text-align: left">
            您目前没有抽奖资格，请满足以下条件后，再点击抽奖
          </p>
          <div :class="$style.rule">
            <p>抽奖规则：</p>
            <p>*累计签到3天可抽取实物大奖</p>
            <p>*累计签到5天可抽取实物大奖</p>
          </div>
        </div>
      </template>
      <template #footer>
        <div :class="$style.footer">
          <button :class="$style['single-btn']" @click="cancle('canNotLottery')">确定</button>
        </div>
      </template>
    </DialogWrapper>
    <DialogWrapper v-if="canNotSign" dialogType="canNotSign">
      <template #title>
        <p>签到失败</p>
      </template>
      <template #main-content>
        <div :class="$style.content">
          <p>今日可签到次数为0</p>
        </div>
      </template>
      <template #footer>
        <div :class="$style.footer">
          <button :class="$style['single-btn']" @click="cancle('canNotSign')">确定</button>
        </div>
      </template>
    </DialogWrapper>
    <DialogWrapper v-if="signDay_1" dialogType="signDay_1">
      <template #title>
        <p>签到成功</p>
      </template>
      <template #main-content>
        <div :class="$style.content">
          <p>恭喜您 <span style="color: rgb(255, 128, 65)">获得领取游戏礼包的资格</span></p>
          <p>再签到2天可获得一次抽取实物大奖机会喔！</p>
        </div>
      </template>
      <template #footer>
        <div :class="$style.footer">
          <button :class="$style['single-btn']" @click="cancle('signDay_1')">确定</button>
        </div>
      </template>
    </DialogWrapper>
    <DialogWrapper v-if="signDay_2" dialogType="signDay_2">
      <template #title>
        <p>签到成功</p>
      </template>
      <template #main-content>
        <div :class="$style.content">
          <p>
            再签到1天即可<span style="color: rgb(255, 128, 65)">获得抽取实物大奖的机会喔！</span>
          </p>
        </div>
      </template>
      <template #footer>
        <div :class="$style.footer">
          <button :class="$style['single-btn']" @click="cancle('signDay_2')">确定</button>
        </div>
      </template>
    </DialogWrapper>
    <DialogWrapper v-if="signDay_3" dialogType="signDay_3">
      <template #title>
        <p>签到成功</p>
      </template>
      <template #main-content>
        <div :class="$style.content">
          <p>恭喜您获得一次抽取实物大奖的机会</p>
          <p style="color: rgb(255, 128, 65)">快参与抽奖吧！</p>
          <p>继续签到2天可再次获得抽取实物大奖的机会!</p>
        </div>
      </template>
      <template #footer>
        <div :class="$style.footer">
          <button :class="$style['single-btn']" @click="cancle('signDay_3')">确定</button>
        </div>
      </template>
    </DialogWrapper>
    <DialogWrapper v-if="signDay_4" dialogType="signDay_4">
      <template #title>
        <p>签到成功</p>
      </template>
      <template #main-content>
        <div :class="$style.content">
          <p>
            再签到1天即可<span style="color: rgb(255, 128, 65)">获得抽取实物大奖的机会喔！</span>
          </p>
        </div>
      </template>
      <template #footer>
        <div :class="$style.footer">
          <button :class="$style['single-btn']" @click="cancle('signDay_4')">确定</button>
        </div>
      </template>
    </DialogWrapper>
    <DialogWrapper v-if="signDay_5" dialogType="signDay_5">
      <template #title>
        <p>签到成功</p>
      </template>
      <template #main-content>
        <div :class="$style.content">
          <p>恭喜您获得一次抽取实物大奖的机会</p>
          <p style="color: rgb(255, 128, 65)">快参与抽奖吧！</p>
          <p>本期签到任务已完成</p>
        </div>
      </template>
      <template #footer>
        <div :class="$style.footer">
          <button :class="$style['single-btn']" @click="cancle('signDay_5')">确定</button>
        </div>
      </template>
    </DialogWrapper>
    <DialogWrapper v-if="signDay_6" dialogType="signDay_6">
      <template #title>
        <p>签到成功</p>
      </template>
      <template #main-content>
        <div :class="$style.content">
          <p>本期签到任务已完成!</p>
        </div>
      </template>
      <template #footer>
        <div :class="$style.footer">
          <button :class="$style['single-btn']" @click="cancle('signDay_6')">确定</button>
        </div>
      </template>
    </DialogWrapper>
    <DialogWrapper v-if="failPickGift" dialogType="failPickGift">
      <template #title>
        <p>领取失败</p>
      </template>
      <template #main-content>
        <div :class="$style.content">
          <p>目前礼包码已领完，小编正在快马加鞭添加!</p>
        </div>
      </template>
      <template #footer>
        <div :class="$style.footer">
          <button :class="$style['single-btn']" @click="cancle('failPickGift')">取消</button>
        </div>
      </template>
    </DialogWrapper>
    <DialogWrapper v-if="successPickGift" dialogType="successPickGift">
      <template #title>
        <p>领取成功</p>
      </template>
      <template #main-content>
        <div :class="$style.content">
          <div :class="$style['input-wrapper']">
            <p>激活码：{{ giftCode }}</p>
            <input id="copyInputOne" :value="giftCode" readonly="readonly" />
          </div>
          <div :class="$style['fail-time']">
            <p>截止时间：{{ failureTime }}</p>
            <p>礼包码仅能使用一次哦!</p>
          </div>
        </div>
      </template>
      <template #footer>
        <div :class="$style.footer">
          <button :class="$style['double-btn']" style="border-right: 1px solid #ececec">
            取消
          </button>
          <button :class="$style['double-btn']">复制激活码</button>
        </div>
      </template>
    </DialogWrapper>
    <DialogWrapper v-if="noGameGift" dialogType="noGameGift">
      <template #title>
        <p>温馨提示</p>
      </template>
      <template #main-content>
        <div :class="$style.content">
          <p>您还没有激活该游戏，请激活后再领取哦!</p>
        </div>
      </template>
      <template #footer>
        <div :class="$style.footer">
          <button
            :class="$style['double-btn']"
            style="border-right: 1px solid #ececec"
            @click="cancle('noGameGift')"
          >
            取消
          </button>
          <button :class="$style['double-btn']" style="color: #06b5ef" @click="downLoad">
            下载游戏
          </button>
        </div>
      </template>
    </DialogWrapper>
    <DialogWrapper
      v-if="lotteryAddress"
      dialogType="lotteryAddress"
      dialogHeight="auto"
      dialogMarginTop="20%"
    >
      <template #title>
        <p>联系方式</p>
      </template>
      <template #main-content>
        <div :class="$style.content">
          <van-form ref="form" validate-first>
            <van-field
              v-model="form.real_name"
              label="姓  名 "
              required
              colon
              :rules="[{ required: true, message: '请填写姓名' }]"
            />
            <van-field name="radio" label="性  别 " required colon>
              <template #input>
                <van-radio-group v-model="form.sex" direction="horizontal">
                  <van-radio name="1">先生</van-radio>
                  <van-radio name="2">女士</van-radio>
                </van-radio-group>
              </template>
            </van-field>
            <van-field
              v-model="form.phone"
              type="phone"
              label="手  机 "
              required
              colon
              :rules="[{ required: true, message: '请填写手机号码' }]"
            />
            <van-field
              name="area"
              :value="province"
              label="所在地区 "
              placeholder="点击选择 ___省 ___市 ___区"
              readonly
              clickable
              required
              colon
              @click="showArea = true"
            />
            <van-popup v-model="showArea" position="bottom">
              <van-area
                :area-list="province_list"
                @confirm="confirmArea"
                @cancel="showArea = false"
              />
            </van-popup>
            <van-field
              :class="$style.address"
              v-model="form.addressDetail"
              label="详细地址 "
              rows="2"
              autosize
              required
              colon
              type="textarea"
              :rules="[{ required: true, message: '请填写详细地址' }]"
            />
            <p :class="$style.tips">请您认真填写地址，因地址填写错误，奖励发放失败，官方概不负责</p>
          </van-form>
        </div>
      </template>
      <template #footer>
        <div :class="$style.footer">
          <button
            :class="$style['double-btn']"
            style="border-right: 1px solid #ececec"
            @click="cancle('lotteryAddress')"
          >
            取消
          </button>
          <button :class="$style['double-btn']" style="color: #06b5ef" @click="submit">确认</button>
        </div>
      </template>
    </DialogWrapper>
    <DialogWrapper v-if="notNeedAddress" dialogType="notNeedAddress">
      <template #title>
        <p>温馨提示</p>
      </template>
      <template #main-content>
        <div :class="$style.content">
          <p>您还没有抽取到实物奖励</p>
          <p>不需要添加地址哦！</p>
        </div>
      </template>
      <template #footer>
        <div :class="$style.footer">
          <button :class="$style['single-btn']" @click="cancle('notNeedAddress')">确定</button>
        </div>
      </template>
    </DialogWrapper>
    <DialogWrapper
      v-if="lotteryResult"
      dialogType="lotteryResult"
      dialogHeight="auto"
      dialogMarginTop="30%"
    >
      <template #title>
        <p>抽奖结果</p>
      </template>
      <template #main-content>
        <div :class="$style.content">
          <div :class="$style.prize">
            <p>恭喜您获得以下奖励</p>
            <img :src="lotteryInfo.icon" />
          </div>
        </div>
      </template>
      <template #footer>
        <div :class="$style.footer">
          <button :class="$style['single-btn']" @click="fillAddress">确定</button>
        </div>
      </template>
    </DialogWrapper>
    <DialogWrapper v-if="lotteryRecord" dialogType="lotteryRecord">
      <template #title>
        <p>{{ lotteryRecordList.length ? '抽奖记录' : '温馨提示' }}</p>
      </template>
      <template #main-content>
        <div :class="$style.content">
          <div v-if="lotteryRecordList.length" :class="$style.record">
            <div v-for="item of lotteryRecordList" :key="item.id">
              <div :class="$style.info">
                <p>{{ item.name }}</p>
                <p>{{ item.created_at }}</p>
              </div>
              <!-- 奖品类型 1 实物奖励 2 虚拟奖励 3 谢谢关注 4 礼包码 -->
              <div v-if="item.type != 3" :class="$style.type">
                <p v-if="item.address_id" style="color: red" @click="getAddressInfo(item)">
                  <!-- 待填写收货地址 -->
                  {{ '填写收货地址' }}
                </p>
                <p v-else :style="{ color: handleColor(item.state) }">
                  {{ handleState(item.state) }}
                </p>
              </div>
            </div>
            <p>五个工作日内审核完毕</p>
          </div>
          <div v-else style="text-align: center">
            <p style="margin: 15px; color: rgb(159, 159, 159)">
              您还没有抽过奖，赶紧去签到抽奖吧！
            </p>
          </div>
        </div>
      </template>
      <template #footer>
        <div :class="$style.footer">
          <button :class="$style['single-btn']" @click="cancle('lotteryRecord')">取消</button>
        </div>
      </template>
    </DialogWrapper>
    <DialogWrapper v-if="noLotteryRecord" dialogType="noLotteryRecord">
      <template #title>
        <p>温馨提示</p>
      </template>
      <template #main-content>
        <div :class="$style.content">
          <p>您还没有抽过奖，赶紧去签到抽奖吧！</p>
        </div>
      </template>
      <template #footer>
        <div :class="$style.footer">
          <button :class="$style['single-btn']" @click="cancle('noLotteryRecord')">确定</button>
        </div>
      </template>
    </DialogWrapper>
    <DialogWrapper v-if="lotteryRule" dialogType="lotteryRule" dialogHeight="350px">
      <template #title>
        <p>抽奖规则</p>
      </template>
      <template #main-content>
        <div :class="$style.content">
          <div :class="$style['lottery-rule']">
            <p>1、微信用户在此页面绑定游戏账号后，即可参与本次活动，游戏账号绑定后不可更改。</p>
            <p>
              2、每个绑定的游戏账号在此页面累计签到达到3天、5天，可各获得一次抽取实物大奖的机会。
            </p>
            <p>
              3、每个绑定的游戏账号，可领取已激活的、参与此次活动的游戏的限量礼包一份，领完即止。
            </p>
            <p>
              4、用户可在抽奖记录中查询自己的中奖信息。若抽到实物奖励，请及时填写收货信息，中奖后7天内未填写收货信息，则视为自动放弃领奖。
            </p>
            <p>5、本次活动解释权归官方所有。</p>
          </div>
        </div>
      </template>
      <template #footer>
        <div :class="$style.footer">
          <button :class="$style['single-btn']" @click="cancle('lotteryRule')">确定</button>
        </div>
      </template>
    </DialogWrapper>
  </div>
</template>

<script>
import DialogWrapper from './DialogWrapper';
import { Dialog, Toast, Form, Field, Popup, Button, RadioGroup, Radio, Area } from 'vant';
import { getAddressInfo, addAddressInfo, getLotteryRecordList } from '@/api/activity';
import province_list from "@/libs/area.js";
import { CDN_URL } from '@/config/index';
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  components: {
    DialogWrapper,
    VanForm: Form,
    VanField: Field,
    VanPopup: Popup,
    vanButton: Button,
    vanField: Field,
    vanRadioGroup: RadioGroup,
    vanRadio: Radio,
    vanArea: Area
  },
  data() {
    return {
      canNotLottery: false,
      canNotSign: false,
      signDay_1: false,
      signDay_2: false,
      signDay_3: false,
      signDay_4: false,
      signDay_5: false,
      signDay_6: false,
      failPickGift: false,
      successPickGift: false,
      noGameGift: false, // 推荐礼包领取时未激活对应游戏时显示
      lotteryAddress: false,
      notNeedAddress: false,
      lotteryResult: false,
      lotteryRecord: false,
      noLotteryRecord: false,
      lotteryRule: false,
      giftCode: '', // 礼包码
      failureTime: '', // 失效时间
      gameUrl: '', // 游戏下载链接
      form: {}, // 地址表单
      showArea: false, // 地区弹窗
      province_list: province_list,
      province: '', // 所选地区
      lotteryInfo: {}, // 抽奖信息
      lotteryRecordList: [], // 抽奖记录列表
    };
  },
  computed: {
    // 活动id
    activityId() {
      return Number(this.$route.query.activityId)
    },
  },
  mounted() {
    // 礼包弹窗
    this.$bus.$on('showGiftDialog', ({ type, giftCode, failureTime, gameUrl }) => {
      if (type === 'successPickGift') {
        this.giftCode = giftCode
        this.failureTime = failureTime
      }
      if (type === 'noGameGift') {
        this.gameUrl = gameUrl
      }
      this.showDialog(type)
    });
    // 抽奖弹窗
    this.$bus.$on('showLotteryDialog', ({ type, lotteryInfo }) => {
      if (type === 'lotteryResult') {
        this.lotteryInfo = { ...lotteryInfo }
      }
      if (type === 'lotteryRecord') {
        this.getLotteryRecordList()
      }
      this.showDialog(type)
    })
  },
  methods: {
    ...mapMutations('app', {
      CHANGE_SHOW_LOADING: 'CHANGE_SHOW_LOADING',
    }),
    // 显示某个弹窗
    showDialog(type, data) {
      this[type] = true
    },
    // 关闭某个弹窗
    cancle(type) {
      this[type] = false
    },
    // 点击下载游戏
    downLoad() {
      window.open(this.gameUrl, "_self");
    },
    // 获取收货地址，并填入表单中，默认是上一次奖品填写的地址
    async getAddressInfo(prizeInfo) {
      this.CHANGE_SHOW_LOADING(true)
      const r = await getAddressInfo()
      if (r.result) {
        Object.assign(this.form, r.data);
        this.province = this.form.address.split('区')[0] + '区';
        this.form.sex = this.form.sex.toString();
        this.form.lottery_log_id = prizeInfo.lottery_log_id;
      } else {
        this.form = {}
      }
      this.CHANGE_SHOW_LOADING(true)
      this.lotteryAddress = true
    },
    // 填写收货地址
    fillAddress() {
      this.lotteryResult = false
      if (this.lotteryInfo.need_address == 1) {
        this.getAddressInfo(this.lotteryInfo)
      }
    },
    // 确认所选地区
    confirmArea(values) {
      this.province = values.map((item) => item.name).join('/');
      this.showArea = false;
    },
    // 提交地址表单，地址跟着奖品走
    async submit() {
      if (!this.form.real_name || !this.form.sex || !this.form.phone || !this.province || !this.form.addressDetail) {
        Dialog.alert({
          title: '温馨提示',
          message: '请确认表单填写完整再提交'
        }).then(() => {
        });
        return
      }
      let address = this.province + this.form.addressDetail
      Object.assign(this.form, {
        address: address
      })
      const r = await addAddressInfo(this.form)
      Toast.success('地址填写成功');
    },
    // 获取抽奖记录列表
    async getLotteryRecordList() {
      const r = await getLotteryRecordList({
        lucky_draw_id: this.activityId
      })
      this.lotteryRecordList = [...r.data]
    },
    // 抽奖记录中审核状态判断字体颜色
    handleColor(state) {
      switch (Number(state)) {
        case 3:
          return '#03b961'
        case 4:
          return '#ff0000'
        default:
          return "#424242"
      }
    },
    // 抽奖状态
    handleState(state) {
      switch (Number(state)) {
        case 1:
          return '待审核';
        case 2:
          return '审核中';
        case 3:
          return '已通过';
        default:
          return '未通过';
      }
    }
  },
}
</script>

<style lang='scss' module>
@import '~@/styles/mixins.scss';
.content {
  width: 100%;
  word-break: break-word;
  line-height: 25px;
  .rule {
    margin-top: 18px;
    font-size: 13px;
  }
  > p {
    text-align: center;
  }
  .input-wrapper {
    > p {
    }
    > input {
    }
  }
  .fail-time {
  }
  .lottery-rule {
    > p {
      font-size: 12px;
    }
  }
  .address {
    // background: pink;
  }
  .tips {
    margin: 15px;
    color: red;
    font-size: 12px;
  }
  .prize {
    margin-top: 10px;
    text-align: center;
  }
  .record {
    > div {
      margin: 15px;
      display: flex;
      flex-direction: column;
      font-size: 14px;
      .info {
        p:last-child {
          margin-top: 8px;
          font-size: 10px;
          color: rgb(159, 159, 159);
        }
      }
      .type {
      }
    }
    > p {
      margin-bottom: 5px;
      color: rgb(159, 159, 159);
      text-align: center;
      font-size: 10px;
    }
  }
}
.footer {
  width: 100%;
  height: 100%;
  > button {
    @include clearBtnDefaultStyle;
    @include border-top-1px;
    height: 100%;
    text-align: center;
    line-height: 100%;
    color: #9f9f9f;
  }
  .double-btn {
    width: 50%;
  }
  .single-btn {
    width: 100%;
  }
}
</style>